<template>
  <v-list two-line subheader :dark="isDark" :class="colorClass">
    <div class="searchInput">
      <v-text-field label="Buscar comprador" clearable v-model="searchField" @keyup.enter="submit"></v-text-field>
    </div>
    <v-list-tile v-for="(ticket, i) in tickets" :key="i" avatar :dark="isDark" :class="colorClass">
      <v-list-tile-content>
        <v-list-tile-title>{{ ticket.buyer }}</v-list-tile-title>
        <v-list-tile-sub-title>{{ ticket.code }}</v-list-tile-sub-title>
      </v-list-tile-content>
      <v-list-tile-action>
        <v-btn icon ripple @click="validate(ticket)">
          <v-icon :dark="isDark" v-if="ticket.status === 'Cancelado'" color="error lighten-1">cancel</v-icon>
          <v-icon :dark="isDark" v-else-if="ticket.readed" color="primary lighten-1">check_circle</v-icon>
          <v-icon :dark="isDark" v-else color="primary lighten-1">check</v-icon>
        </v-btn>
      </v-list-tile-action>
    </v-list-tile>
  </v-list>
</template>

<script>
export default {
  data() {
    return {
      searchField: null
    }
  },
  watch: {
    searchField(value) {
      if (value === '') {
        this.searchField = null
      }
    }
  },
  computed: {
    eventId() {
      return this.$store.getters.selectedEvent.id
    },
    tickets() {
      return this.$store.getters.tickets.filter(ticket => {
        if (ticket.buyer) {
          return ticket.buyer.includes(this.searchField) || this.searchField === null
        }
      })
    },
    colorClass() {
      return this.$store.getters.colorClass
    },
    isDark() {
      return this.$store.getters.isDark
    }
  },
  methods: {
    validate(ticket) {
      this.$store.dispatch('readTicket', { ticket: ticket.code, eventId: this.eventId })
    }
  }
}
</script>

<style>
.searchInput {
  padding: 0 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/validation/ListValidation.vue